import { Fragment } from "react";
import { CardHeader } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { CommonCardHeaderProp } from "../../../Types/CommonComponentsType";

const CommonCardHeader: React.FC<CommonCardHeaderProp> = ({ title, span, headClass, icon, tagClass, tag }) => {
  return (
    <CardHeader className={headClass ? headClass : "pb-0"}>
      <H4 className={tagClass ? tagClass : ""}>
        {icon && icon}
        {title}
      </H4>
      {span &&
        (tag ? (
          <span className="f-m-light mt-1">
            {span.map((data, index) => (
              <Fragment key={index}>
                {data?.text} {data.code && <code>{data.code}</code>} {data.mark && <mark>{data.mark}</mark>}
              </Fragment>
            ))}
          </span>
        ) : (
          <P className="f-m-light mt-1">
            {span.map((data, index) => (
              <Fragment key={index}>
                {data?.text} {data.code && <code>{data.code}</code>} {data.mark && <mark>{data.mark}</mark>}
              </Fragment>
            ))}
          </P>
        ))}
    </CardHeader>
  );
};

export default CommonCardHeader;
